import { ReactElement } from 'react';
import LoadMoreButton from '@rio-cloud/rio-uikit/components/loadMore/LoadMoreButton';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { CustomFormattedMessage } from '../../i18n/i18n';

type PaginationProps = {
  loadedItems: number;
  totalItems: number;
  onLoadMore: () => void;
  isLoading: boolean;
};

export const Pagination = ({
  loadedItems,
  totalItems,
  onLoadMore,
  isLoading = false,
}: PaginationProps): ReactElement => (
  <LoadMoreButton
    data-testid={'pagination'}
    loaded={loadedItems}
    total={totalItems}
    onLoadMore={onLoadMore}
    isInteractive={!isLoading}
    loadMoreMessage={
      isLoading ? (
        <Spinner />
      ) : (
        <CustomFormattedMessage id="pagination.loadMore" />
      )
    }
    noMoreMessage={<CustomFormattedMessage id="pagination.noMoreItems" />}
  />
);
